module.exports = __webpack_public_path__ + "img/hero-default-desktop.png";